import React, { useContext, useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import container from "../../../../styles/Global.module.css";
import { UserContext } from "../../../../UserContext";
import { separateMasterPerformanceItems } from "../../../../utils/boards/boardFilters";
import BaseBoard from "../../../global/BoardTemplate/BaseBoard.jsx";
import { createStandardColumns } from "../../../../utils/boards";
import { fetchData } from "../../../../utils/ApiCall";
import { getMasterPerformanceColumns } from "../../../../config/columns/masterPerformanceColumns";
import {
  mapFilterOptions,
  mapFilterOptionsCode,
  OptionsFromColumns,
} from "../../../../utils/masterPerformanceHelpers";
import { useMasterPerformanceEdit } from "../../../../hooks/useMasterPerformanceEdit";
import ViewsPerformance from "../../../others/ViewsPerformance.jsx";
import { GridLogicOperator } from "@mui/x-data-grid-pro";

const AlunaMasterPerformance = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const apiUrl = `${backendUrl}/api/master-performance/items`;
  const { key, setKey } = useContext(UserContext);

  const [state, setState] = useState({
    offerID: [],
    inactive: [],
    notProfitable: [],
    selectionRow: [],
    viewFilter: {
      items: [],
      quickFilterLogicOperator: GridLogicOperator.Or,
    },
    columnsFilter: { id: false },
    pinnedColumns: {
      left: ["__check__", "offerID", "threads", "offerTitle"],
      right: [],
    },
    selectedView: "tabla-principal",
    payoutAceptado: "",
    cap: "",
    capMensual: "",
    revenueMonedaAnunciante: "",
    density: "standard",
  });

  useEffect(() => {
    setKey(localStorage?.getItem("jwt"));
  }, [setKey]);

  const updateState = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates }));
  };

  // Load data ourselves instead of relying on BaseBoard/useBoard
  useEffect(() => {
    const loadData = async () => {
      if (key && apiUrl) {
        try {
          console.log("Loading data from:", apiUrl);
          const data = await fetchData(apiUrl);
          console.log("Data loaded:", data?.length, "items");

          const separated = separateMasterPerformanceItems(data);
          updateState({
            offerID: separated.offerID,
            inactive: separated.inactive,
            notProfitable: separated.notProfitable,
          });
        } catch (error) {
          console.error("Error loading data:", error);
        }
      }
    };

    loadData();
  }, [key, apiUrl]);

  // Dummy function for BaseBoard
  const stableSetGroupItems = useCallback(() => {
    // Do nothing - we handle data loading ourselves
  }, []);

  const getGroupRows = useCallback(
    (groupName) => {
      return groupName === "Offer ID"
        ? state.offerID
        : groupName === "Inactive"
        ? state.inactive
        : groupName === "Not profitable"
        ? state.notProfitable
        : [];
    },
    [state.offerID, state.inactive, state.notProfitable]
  );

  // Use custom hooks for edit logic
  const { handleEditResponseChange, controlEdit, updateBoard } =
    useMasterPerformanceEdit(state, updateState, pathname);

  // Get columns from external config
  const columnFactory = createStandardColumns();
  const columns = React.useMemo(() => {
    return getMasterPerformanceColumns(
      state,
      { handleEditResponseChange, updateState },
      {
        mapFilterOptions,
        mapFilterOptionsCode,
        OptionsFromColumns,
        columnFactory,
      },
      { backendUrl, key, pathname }
    );
  }, [
    state,
    handleEditResponseChange,
    updateState,
    backendUrl,
    key,
    pathname,
    columnFactory,
  ]);

  return (
    <div className={container.globalContainer} style={{ padding: "10px 30px" }}>
      <ViewsPerformance
        setViewFilter={(viewFilter) => updateState({ viewFilter })}
        setColumnsFilter={(columnsFilter) => updateState({ columnsFilter })}
        setPinnedColumns={(pinnedColumns) => updateState({ pinnedColumns })}
        setTables={(groups) => updateState({ groups })}
        setSelectedView={(selectedView) => updateState({ selectedView })}
        selectedView={state.selectedView}
        setDensity={(density) => updateState({ density })}
        density={state.density}
      />
      <BaseBoard
        columns={columns}
        groups={["Offer ID", "Inactive", "Not profitable"]}
        getGroupRows={getGroupRows}
        setGroupItems={stableSetGroupItems}
        apiUrl={null}
        controlEdit={controlEdit}
        refreshState={false}
        updateBoard={updateBoard}
        updateRows={[]}
        selectionRow={state.selectionRow}
        setSelectionRow={useCallback(
          (selectionRow) => updateState({ selectionRow }),
          []
        )}
        viewFilter={state.viewFilter}
        setViewFilter={(viewFilter) => updateState({ viewFilter })}
        columnsFilter={state.columnsFilter}
        setColumnsFilter={(columnsFilter) => updateState({ columnsFilter })}
        pinnedColumns={state.pinnedColumns}
        setPinnedColumns={(pinnedColumns) => updateState({ pinnedColumns })}
        checkboxSelection={true}
        height="80vh"
        maxHeight="80vh"
        pathname={pathname}
      />
    </div>
  );
};

export default AlunaMasterPerformance;
